import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { AttentionState } from "./operations-shared";

interface HealthBadgeProps {
  state: AttentionState;
  reason?: string;
  className?: string;
}

const HEALTH_STYLES: Record<AttentionState, string> = {
  Ready:
    "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-900 dark:bg-emerald-950/50 dark:text-emerald-300",
  "Needs Action":
    "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-900 dark:bg-amber-950/50 dark:text-amber-300",
  "Awaiting Approval":
    "border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-900 dark:bg-sky-950/50 dark:text-sky-300",
  "At Risk":
    "border-orange-200 bg-orange-50 text-orange-700 dark:border-orange-900 dark:bg-orange-950/50 dark:text-orange-300",
  Blocked:
    "border-destructive/30 bg-destructive/10 text-destructive",
  Complete:
    "border-sky-200 bg-sky-50 text-sky-700 dark:border-sky-900 dark:bg-sky-950/50 dark:text-sky-300",
};

export function HealthBadge(props: Readonly<HealthBadgeProps>) {
  const { state, reason, className } = props;
  const badge = (
    <Badge
      variant="outline"
      className={cn("cursor-help border px-2.5 py-1 font-medium", HEALTH_STYLES[state], className)}
    >
      {state}
    </Badge>
  );

  if (!reason || reason.trim().length === 0) {
    return badge;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{badge}</TooltipTrigger>
      <TooltipContent sideOffset={6} className="text-black">
        {reason}
      </TooltipContent>
    </Tooltip>
  );
}

export type { AttentionState };
